import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { markerTypes } from '../../../../../services/util/mapUtils';
import L from 'leaflet';
import 'leaflet.markercluster/dist/leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import { useLeaflet } from 'react-leaflet';
import { withTranslation } from 'react-i18next';

const TemplateStopOverlappingMarkerCluster = (props) => {
  const {
    getUnassignedTemplateStopStopMarkerAndAddToMcg,
    getTemplateStopMarkerAndAddToMcg,
    overlappingElements,
    getClusterIcon,
    t,
    highLiteDuplicates,
    overlappingPolyLines,
  } = props;

  const mcg = L.markerClusterGroup({
    iconCreateFunction: () =>
      getClusterIcon(overlappingElements, highLiteDuplicates),
    maxClusterRadius: 50,
    showCoverageOnHover: false,
    disableClusteringAtZoom: 20,
    spiderfyOnMaxZoom: true,
  });

  const { map } = useLeaflet();

  useEffect(() => {
    mcg.clearLayers();
    const addedPolylines = [];
    // Add markers to the cluster group
    overlappingElements.forEach((el) => {
      switch (el.type) {
        case markerTypes.templateStop:
          if (getUnassignedTemplateStopStopMarkerAndAddToMcg)
            getUnassignedTemplateStopStopMarkerAndAddToMcg(
              el.templateStop,
              mcg,
              t,
              el.selected
            );
          break;
        case markerTypes.template:
          if (getTemplateStopMarkerAndAddToMcg)
            getTemplateStopMarkerAndAddToMcg(
              el.template,
              el.templateStop,
              el.stopNumber,
              mcg,
              t,
              el.selected
            );
          break;
        default:
          console.warn(
            `Encountered marker type where no marker was specified: ${el.type}`
          );
      }
    });

    // Add polylines
    if (overlappingPolyLines?.length > 0) {
      const baseLine = new L.Polyline(
        overlappingPolyLines[0].polyLine.positions,
        { color: overlappingPolyLines[0].polyLine.color }
      ).addTo(map);
      addedPolylines.push(baseLine);

      if (overlappingPolyLines.length > 1) {
        const overlayLine = new L.Polyline(
          overlappingPolyLines[1].polyLine.positions,
          {
            color: overlappingPolyLines[1].polyLine.color,
            dashArray: '8, 12',
          }
        ).addTo(map);
        overlayLine.bringToFront();
        addedPolylines.push(overlayLine);
      }
    }

    map.addLayer(mcg);

    // Cleanup
    return function cleanup() {
      map.removeLayer(mcg);
      addedPolylines.forEach((line) => map.removeLayer(line));
    };
  }, [
    overlappingElements,
    getClusterIcon,
    highLiteDuplicates,
    getUnassignedTemplateStopStopMarkerAndAddToMcg,
    getTemplateStopMarkerAndAddToMcg,
    t,
    map,
    overlappingPolyLines,
    mcg,
  ]);

  return null;
};

TemplateStopOverlappingMarkerCluster.propTypes = {
  getClusterIcon: PropTypes.func.isRequired,
  getUnassignedTemplateStopStopMarkerAndAddToMcg: PropTypes.func,
  getTemplateStopMarkerAndAddToMcg: PropTypes.func,
  highLiteDuplicates: PropTypes.bool.isRequired,
  overlappingElements: PropTypes.array.isRequired,
  overlappingPolyLines: PropTypes.array,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TemplateStopOverlappingMarkerCluster);
